import * as React from "react";

import { proto } from "../../proto";
import { CHECKOUT_CART_PATH } from "../../constants/Paths";
import { alert } from "../../js/shared/alert";
import { getCreditCardError } from "../shared/getCreditCardError";
import { getErrorMessage } from "../shared/Errors";

type Props = {
  errors?: proto.ValidationError.IFieldViolation[];
  showErrorAndRedirectToCart?: boolean;
  translateMessage?: string;
};

const TIMEOUT = 3000;

const goBackToCart = () => {
  window.location.href = CHECKOUT_CART_PATH;
};

const Popup = ({ errors, showErrorAndRedirectToCart }: Props) => {
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  const onClose = React.useCallback(() => {
    if (showErrorAndRedirectToCart) {
      goBackToCart();
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, [showErrorAndRedirectToCart]);

  React.useEffect(() => {
    if (errors && errors.length > 0) {
      const { msg } = getCreditCardError(errors);
      const errorMessage = getErrorMessage({ msg, errors });
      const displayText =
        typeof errorMessage === "string"
          ? errorMessage
          : errorMessage.join(",");

      alert(displayText, onClose);

      if (showErrorAndRedirectToCart) {
        timerRef.current = setTimeout(() => {
          if (showErrorAndRedirectToCart && timerRef.current) {
            goBackToCart();
          } else {
            if (timerRef.current) {
              clearTimeout(timerRef.current);
            }
          }
        }, TIMEOUT);
      } else {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      }
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [errors, onClose, showErrorAndRedirectToCart]);

  return null;
};

export default Popup;
